const fontSizes = {
  lg: '2.4rem',
  md: '1.8rem',
  ms: '1.6rem',
  base: '1.4rem',
  sm: '1.2rem',
  sx: '1rem',
};

export const lightModeColors = {
  colors: {
    primary: '#ff7d7d;',
    secondary: '#f8c4b4',
    tertiary: '#b4de94',
    warning: '#eb5757',
    border: '#dbdbdb',
    background: '#dbdbdb',
    subBackground: '#F2F2F2',
    mainText: '#000',
    subText: '#767676',
    placeholder: '#c4c4c4',
    ground: '#ffffff',
    white: '#ffffff',
    black: '#000000',
    backgroundColor: '#ffffff',
  },
  fontSizes: { ...fontSizes },
};

export const darkModeColors = {
  colors: {
    primary: '#ff7d7d;',
    secondary: '#f8c4b4',
    tertiary: '#b4de94',
    warning: '#eb5757',
    border: '#000000',
    background: '#dbdbdb',
    subBackground: '#666',
    mainText: '#fff',
    subText: '#767676',
    placeholder: '#c4c4c4',
    ground: '#333',
    white: '#ffffff',
    black: '#000000',
    backgroundColor: '#333',
  },
  fontSizes: { ...fontSizes },
};

// const GlobalTheme = {
//   lightModeColors,
//   darkModeColors,
// };

// export default GlobalTheme;
